import {
  gql,
} from 'apollo-boost';

export default gql `
mutation($clientId: ID!, $jobId: ID!) {
  removeJobClient(clientId: $clientId, jobId: $jobId)
}
`;